import token, { tokenToVars } from '../token';
import Select from './select';

export { Select };
export default tokenToVars(Select, token);
